// LICENSE_CODE ZON
'use strict';
/*jslint browser:true, es6:true, node:true, react:true*/
import {useRef, useEffect} from 'react';

export function use_state_ref<T>(state: T){
    const state_ref = useRef<T>(state);
    useEffect(()=>{ state_ref.current = state; }, [state]);
    return state_ref;
}
